<script lang="ts">
    import { yLineInterval } from "../config/lengths";

    export let x: number;
    export let y: number;
    export let isUpward: boolean;

    $: scale = yLineInterval / 32;

    $: transform = isUpward
        ? "scale(" +
          String(scale) +
          ")" +
          " translate(" +
          String(x / scale) +
          " " +
          String(y / scale) +
          ")"
        : "scale(" +
          String(scale) +
          " " +
          String(-scale) +
          ")" +
          " translate(" +
          String(x / scale) +
          " " +
          String(-y / scale) +
          ")";
</script>

<g {transform}>
    <path
        style="fill: #000000; fill-rule: evenodd; stroke-width: 0"
        d="m 0.113867,0.20079656 v 21.61443344 c 0,0 0.94525,0.775951 2.86031,2.119063 2.96256,2.077769 11.72672,8.492441 16.30379,12.502468 4.32124,3.785882 7.681543,8.792106 9.319493,15.513061 1.258269,5.16302 1.321855,12.292274 -0.265093,23.414637 -0.625691,4.385252 -1.941261,8.962125 -1.382021,9.232105 0.79714,0.384835 1.896245,-2.183046 3.893566,-8.663834 4.282742,-13.896389 4.991739,-23.375438 3.552129,-34.072048 -1.191249,-8.851234 -5.233083,-18.442826 -10.683243,-24.645333 -6.742451,-7.6731876 -14.71934,-13.1198991 -19.5333,-15.3462212 -2.59687,-1.20097884 -4.06563,-1.66833124 -4.065631,-1.66833124 z"
    />
    <path
        style="fill: #000000; fill-rule: evenodd; stroke-width: 0"
        d="m 0.113867,32.195094 v 21.614433 c 0,0 0.94525,0.775952 2.86031,2.119063 2.96256,2.07777 11.726721,8.492442 16.303791,12.502468 4.32124,3.785882 8.60276,8.976349 9.13525,14.223357 0.53655,5.286978 -1.14271,12.289105 -4.70907,19.650585 -1.9313,3.98648 -3.62376,6.09198 -3.06452,6.36196 0.79714,0.38483 2.7385,-2.2073 6.4668,-7.87207 6.32003,-9.602649 7.43952,-18.822708 6.55264,-25.650208 -1.15046,-8.856628 -2.28519,-17.337365 -9.94627,-25.935035 -6.79549,-7.626256 -14.719341,-13.119899 -19.533301,-15.346221 -2.59687,-1.200979 -4.06563,-1.668332 -4.06563,-1.668332 z"
    />
</g>
